export default "__VITE_ASSET__nhQ54R29__"